import React from 'react';
import { motion } from 'framer-motion';
import { alyssa, caleb } from '../assets';
import { FaCross } from 'react-icons/fa';

const Introduction = () => {
  return (
    <section className="relative flex items-start justify-center overflow-hidden py-32">
      {/* Animated background */}
      <div className="absolute inset-0 bg-cream -z-10">
        <div className="absolute -top-1/2 -right-1/5 w-[800px] h-[800px] bg-sage/10 rounded-full blur-3xl animate-float" />
        <div className="absolute -bottom-1/3 -left-1/10 w-[600px] h-[600px] bg-terracotta/20 rounded-full blur-3xl animate-float"
              style={{ animationDuration: '15s', animationDirection: 'reverse' }} />
      </div>

      <div className="relative z-10 text-center max-w-5xl px-8">
        <motion.div
          className="text-sm uppercase text-sage-dark mb-8 font-body font-semi"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <p className=''>Together with families, <br/> we joyfully request the pleasure of your company as we celebrate the wedding of</p>
        </motion.div>

        <div className="flex items-center justify-center flex-col lg:flex-row">

          <div className="flex flex-col md:flex-col-reverse justify-start">
            <motion.div
              className="text-sm uppercase text-sage-dark font-body"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              <p>
                second son of <br/><br/>
                Mr. Gerry Kusmana & <br/> Mrs. Henny Yulianty
              </p>
            </motion.div>
            <motion.div
              className="bg-sage-dark shadow-[0_0_10px_rgba(201,169,97,0.3)] mx-auto my-10 max-w-56 rounded-lg overflow-hidden"
              initial={{ opacity: 0 }}
              animate={{ opacity: 100 }}
              transition={{ duration: 1, delay: 1.5 }}
            >
              <img src={caleb} alt="" className='aspect-[1/1.5]'/>
            </motion.div>
            <motion.p
              className="text-4xl md:text-5xl font-display italic text-sage-dark"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1.8 }}
            >
              Caleb Ignatius
            </motion.p>
          </div>

            <motion.p
              className="text-6xl md:text-6xl font-display italic text-sage-dark mx-8 my-10"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1.8 }}
            >
              &
            </motion.p>

          <div className="flex flex-col justify-start self-stretch">
            <motion.p
              className="text-4xl md:text-5xl font-display italic text-sage-dark"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1.8 }}
            >
              Alyssa Christella
            </motion.p>
            <motion.div
              className="bg-sage-dark shadow-[0_0_10px_rgba(201,169,97,0.3)] mx-auto my-10 max-w-56 rounded-lg overflow-hidden"
              initial={{ opacity: 0 }}
              animate={{ opacity: 100 }}
              transition={{ duration: 1, delay: 1.5 }}
            >
              <img src={alyssa} alt="" className='aspect-[1/1.5]'/>
            </motion.div>
             <motion.div
              className="text-sm uppercase text-sage-dark font-body"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              <p>
                First daughter of <br/><br/>
                (<FaCross className='inline-block'/>)  Adrian Adhikrisnan & <br/> Esther R. Kenchana
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;
